var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_vm._t("default"),_c('span',{staticClass:"ml-5 d-none d-md-block",domProps:{"innerHTML":_vm._s(_vm.course.title)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }